// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root___boii","range":"MonthRangeSwitch_range__3jPy7","disabled":"MonthRangeSwitch_disabled__1hIsT"};